<template>
  <el-form
    ref="form"
    label-position="top"
    :model="form"
    :rules="rules"
  >
    <el-row :gutter="20">
      <el-col :xs="24" :sm="showEmail ? 24 : 12">
        <el-form-item
          label="Full name of rights holder"
          prop="name"
        >
          <el-input
            v-model="form.name"
            auto-complete="name"
            @input="input"
            :disabled="!editable"
          />
        </el-form-item>
      </el-col>

      <el-col v-if="showEmail" :xs="24" :sm="12">
        <el-form-item
          label="Email"
          prop="email"
        >
          <el-input
            v-model="form.email"
            auto-complete="email"
            @input="input"
            :disabled="!editable"
          />
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12">
        <el-form-item
          label="Contact number"
          prop="contact_number"
        >
          <sh-el-tel-input
            v-model="form.contact_number"
            :disabled="!editable"
          ></sh-el-tel-input>
          <el-input style="display: none;" :value="form.contact_number"/>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12">
        <el-form-item
          label="Address"
          prop="address"
        >
          <el-input
            v-model="form.address"
            auto-complete="address-line1"
            @input="input"
            :disabled="!editable"
          />
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="6">
        <el-form-item
          label="City"
          prop="city"
        >
          <el-input
            v-model="form.city"
            auto-complete="address-level2"
            @input="input"
            :disabled="!editable"
          />
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="6">
        <el-form-item
          label="Postal Code"
          prop="postal_code"
        >
          <el-input
            v-model="form.postal_code"
            auto-complete="postal-code"
            @input="input"
            :disabled="!editable"
          />
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12">
        <el-form-item
          label="Country"
          prop="country"
        >
          <el-select
            v-model="form.country"
            :disabled="!editable"
            filterable
            @input="input"
          >
            <el-option
              v-for="item in countries"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12">
        <el-form-item
          label="Company name"
          prop="company_name"
        >
          <el-input
            v-model="form.company_name"
            auto-complete="off"
            @input="input"
            :disabled="!editable"
          />
        </el-form-item>
      </el-col>

      <el-col v-if="showReferral" :xs="24" :sm="12">
        <el-form-item
          label="Referral"
          prop="referral"
        >
          <p class="instruction">
            Film festival or curator who recommended you to Viddsee
          </p>
          <el-input
            v-model="form.referral"
            auto-complete="off"
            @input="input"
          />
        </el-form-item>
      </el-col>

    </el-row>
  </el-form>
</template>

<script>
import formValidationMixin from '@/mixins/formValidationMixin';
import selectorDataMaker from '@/utils/selectorDataMaker';
// Data
import countriesData from '@/assets/data/countries';


export default {
  mixins: [
    formValidationMixin,
  ],
  props: {
    value: {},
    editable: {
      type: Boolean,
      default: true,
    },
    showReferral: {
      type: Boolean,
      default: true,
    },
    showEmail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        ...this.value,
      },
      rules: {
        name: [
          { required: true, trigger: 'change' },
        ],
        email: [
          { type: 'email', trigger: 'blur' },
          { required: true, trigger: 'change' },
        ],
        contact_number: [
          { required: true, trigger: 'change', message: 'contact number is required' },
          { min: 6, trigger: 'blur', message: 'contact number is required' },
        ],
        address: [
          { required: true, trigger: 'change' },
        ],
        city: [
          { required: true, trigger: 'change' },
        ],
        postal_code: [
          { required: true, trigger: 'change' },
        ],
        country: [
          { required: true, trigger: 'change' },
        ],
        company_name: [
        ],
      },
      countries: selectorDataMaker.make(countriesData),
    };
  },
  methods: {
    input() {
      this.$emit('input', this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-select {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile/FilmmakerDetailsForm.vue